<form class="m-t-24" [formGroup]="fechasGroup">
	<mat-card class="cardWithShadow">
		<mat-card-content class="p-5">
			<div class="row d-flex" >
				<div class="col-md-2 d-flex">
					<mat-form-field appearance="outline" class="w-100">
						<mat-label>Fecha inicio</mat-label>
						<input matInput [matDatepicker]="fechaInicio" formControlName="fechaInicio"/>
						<mat-hint>DD/MM/YYYY</mat-hint>
						<mat-datepicker-toggle matIconSuffix [for]="fechaInicio"></mat-datepicker-toggle>
						<mat-datepicker touchUi #fechaInicio></mat-datepicker>
					</mat-form-field>
				</div>

				<div class="col-md-2 d-flex">
					<mat-form-field appearance="outline" class="w-100">
						<mat-label>Fecha fin</mat-label>
						<input matInput [matDatepicker]="fechaFin" formControlName="fechaFin"/>
						<mat-hint>DD/MM/YYYY</mat-hint>
						<mat-datepicker-toggle matIconSuffix [for]="fechaFin"></mat-datepicker-toggle>
						<mat-datepicker touchUi #fechaFin></mat-datepicker>
					</mat-form-field>
				</div>		

						
				<div class="col-md-2 d-flex">
					<button mat-flat-button (click)="generarLogs()" color="primary" class="w-100">
						<mat-icon matPrefix class="op-5">import_export</mat-icon>
						Generar Log
					</button>
				</div>
			</div>
		</mat-card-content>
	</mat-card>
</form>